/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RecommendationViewerAliases {
  EXECUTE_TIME_BUTTON = 'execute-time-button',
  EXECUTE_TIME_PANEL = 'execute-time-panel',
  GLOBAL_ACTIONS = 'global-actions',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  PANEL_HEADER = 'panel-header',
  PANEL_RECOMMENDATION_VIEWER_CONTENT = 'panel-recommendation-viewer-content',
  RECOMMENDATION_DETAILS_CARD = 'recommendation-details-card',
  RECOMMENDATION_FOOTER_PANEL = 'recommendation-footer-panel',
  RECOMMENDATION_VIEWER_CONTEXTUAL_BAR = 'recommendation-viewer-contextual-bar',
  RECOMMENDATION_VIEWER_DECK = 'recommendation-viewer-deck',
  RECOMMENDATION_VIEWER_LAYOUT = 'recommendation-viewer-layout',
  RESCHEDULE_RECOMMENDATION_ACTION = 'reschedule-recommendation-action',
  SUSPEND_RECOMMENDATION_ACTION = ' suspend-recommendation-action',
}
export { RecommendationViewerAliases };
